import { render } from "./QuestionTemplate.vue?vue&type=template&id=f416f382&scoped=true"
import script from "./QuestionTemplate.vue?vue&type=script&lang=js"
export * from "./QuestionTemplate.vue?vue&type=script&lang=js"

import "./QuestionTemplate.vue?vue&type=style&index=0&id=f416f382&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f416f382"]])

export default __exports__